module.exports = __webpack_public_path__ + "media/images/icons/flags/VU-e3bb51cdb27308bd59853fee5f350b3a.svg";